import customAxios from "../../customAxios";
import { DELETE_MUNICIPALITY } from "../../routes";
// import {DELETE_COMPANY} from "../../routes";

const deleteMunicipality = async (userId: string) => {
  try {
    return (await customAxios.delete(DELETE_MUNICIPALITY + `/${userId}`)).data;
  } catch (error: any) {
    console.log({ DELETE_MUNICIPALITY: error });
    return false;
  }
};

export default deleteMunicipality;
